<template>
  <div>
    <md-dialog :md-active="open" class="modal-agg-category">
      <span
        class="material-icons close text-right"
        @click="closeModal"
      >close</span
      >
      <div class="body-modal-agg-category">
        <md-dialog-title>COMPARTIR CATEGORIA</md-dialog-title>

        <div id="multiselect-partners" class="form-group mt-3">
          <Multiselect
            v-model="partners"
            tag-placeholder="Add this as new tag"
            placeholder="Busca por correo"
            label="name"
            track-by="id"
            :options="getPartnerUsers"
            :multiple="true"
            :taggable="true"
          >
            <template #noResult>
              <div>Sin resultados</div>
            </template>
          </Multiselect>
        </div>

        <md-dialog-actions>
          <md-button
            class="md-button md-primary md-theme-default"
            @click="closeModal"
          >CANCELAR
          </md-button
          >
          <base-button
            :loading="isLoading"
            class="md-primary w-100 "
            @click="send()"
          >
            GUARDAR
          </base-button>
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import {
  MEDIA_SHARE_CATEGORY_WITH_FILES,
} from '@/store/actions/media';
import partner from '@/store/modules/partner';

export default {
  components: {
    Multiselect,
  },
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  emits: ['close-modal', 'success'],
  data () {
    return {
      partners: [],
      isLoading: false,
    };
  },
  computed: {
    partner () {
      return partner;
    },
    open: {
      // getter
      get: function() {
        return this.active;
      },
      // setter
      set: function() {
        this.closeModal();
      },
    },
    ...mapGetters(['getPartnerUsers']),
  },
  watch: {
    item: function(value) {
      this.partners = value.users;
    },
  },
  methods: {
    notifyAlert (message = '', type = 'success') {
      this.$notify({
        type,
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        message,
      });
    },
    closeModal () {
      this.$emit('close-modal', 'shareCategoryFile');
      this.partners = [];
    },
    async send () {
      this.isLoading = true;
      const partnerIds = this.partners.map((partner) => partner.id);
      const data = { ids: partnerIds, fileId: this.item.id };

      try {
        await this.$store
          .dispatch(MEDIA_SHARE_CATEGORY_WITH_FILES, data);
        this.notifyAlert('Se ha compartido la categoria con los socios');
        this.$emit('success');
      } catch {
        this.notifyAlert('Tenemos problemas para compartir la categoria con los socios', 'danger');
        return this.isLoading = false;
      }

      this.isLoading = false;

      return this.closeModal();

    },
  },
};
</script>

<style scoped>


#multiselect-partners >>> .multiselect__tag {
  background-color: #b7227e !important;
  line-height: 25px !important;
}

#multiselect-partners >>> .multiselect__tag-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

#multiselect-partners >>> .multiselect__tag .multiselect__tag-icon:after {
  color: white;
  font-size: 20px !important;
  line-height: 0 !important;
  font-weight: 400 !important;
}

#multiselect-partners >>> .multiselect__tag .multiselect__tag-icon:hover {
  color: white;
  background-color: #b7227e;
}

#multiselect-partners >>> .multiselect__input,
.multiselect__tag {

  line-height: 20px !important;
}

#multiselect-partners >>> .multiselect__input {
  padding: 0px !important;
  font-size: 16px;
  letter-spacing: 0.01em;
}

#multiselect-partners >>> .multiselect__select {
  height: 50px;
  width: 50px;
}

#multiselect-partners >>> .multiselect__option--selected {
  background: #b5016d !important;
  color: #fff !important;
  font-weight: 500 !important;
}

#multiselect-partners >>> .multiselect--above .multiselect__content-wrapper {
  top: 100% !important;
  bottom: auto !important;
}

#multiselect-partners >>> .multiselect__option--highlight {
  background: black;
  outline: none;
  color: #fff;
}

#multiselect-partners >>> .multiselect__option--highlight::after {
  background: black;
  outline: none;
  color: #000;
}
</style>